module.exports = __webpack_public_path__ + "img/ddwu_main2.f97e4632.jpg";